import { css } from 'styled-components';

const CheckboxLabel = css`
position: relative;
cursor: pointer;
color: #4A4A4A;
font-size: 14px;
&:before {
  content:'';
  transition: all 0.5s;
  -webkit-appearance: none;
  background-color: transparent;
  border: 2px solid #ACC2D3;
  box-shadow: none;
  display: inline-block;
  position: relative;
  vertical-align: middle;
  cursor: pointer;
  margin-right: 10px;
  border-radius: 3px;
  height:18px;
  width: 18px;
  top: -2px;
}
`;

export default CheckboxLabel;
